import { TranslateService } from '@ngx-translate/core';
import { get } from 'lodash';
import { IotMapMarkerPopup, IotMapMarkerPopupOptions, IotMapMarkerPopupRawData } from './iot-map-marker-popup.model';

export class IotMapMarkerAssetsPopupModel extends IotMapMarkerPopup {
  constructor(
    protected translateService: TranslateService,
    options?: Partial<IotMapMarkerPopupOptions>
  ) {
    super(options);
    this.templateRows = [
      {
        label: this.translateService.instant('IOT_DICTIONARY.site'),
        cb: (rawData: IotMapMarkerPopupRawData) => get(rawData, 'feature.properties.siteName')
      },
      {
        label: this.translateService.instant('IOT_DICTIONARY.asset'),
        cb: (rawData: IotMapMarkerPopupRawData) => get(rawData, 'feature.properties.name')
      },
      {
        label: 'Variable',
        cb: (rawData: IotMapMarkerPopupRawData) => get(rawData, 'feature.options.value') + ' ' + get(rawData, 'feature.options.unit')
      },
      {
        label: 'Date',
        cb: (rawData: IotMapMarkerPopupRawData) => get(rawData, 'feature.options.datetime')
      }
    ];
  }
}
